import { render, staticRenderFns } from "./SettingsTab.vue?vue&type=template&id=554e174c&scoped=true&lang=pug&"
import script from "./SettingsTab.vue?vue&type=script&lang=js&"
export * from "./SettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTab.vue?vue&type=style&index=0&id=554e174c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554e174c",
  null
  
)

export default component.exports